/** Po zapisie kolejności kategorii — inne edytory odświeżają sortowanie grup. */
export const CATEGORIES_REORDERED_EVENT = 'iptv-categories-reordered';

export type CategoriesReorderedDetail = { playlistId: string };

export const CATEGORY_EDITOR_TOOLBAR_EVENT = 'iptv-category-editor-toolbar';
export const CATEGORY_EDITOR_SHOW_DELETED_STATE_EVENT = 'iptv-category-show-deleted-state';

export type CategoryEditorToolbarCommand = 'toggle-show-deleted';

export type CategoryEditorToolbarDetail = {
  command: CategoryEditorToolbarCommand;
};

export type CategoryEditorShowDeletedStateDetail = {
  includeDeleted: boolean;
};
